
import React, { useEffect, useState, useMemo } from 'react';
import { Link, withRouter } from "react-router-dom";
import { Dropdown, Modal, Button } from "react-bootstrap";
import Alert from '../Services/Alert';
import Api from '../Services/Api';
import DataTable from 'react-data-table-component';

export const NotificationList = (props) => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);

    const onDelete = (id) => {
        Alert.warning().then((result) => {
            if (result.isConfirmed) {
                Api.post("notification/delete", { id: id }).then((res) => res.data).then(res => {
                    if (res.status) {
                        Alert.success(res.message);
                        notificationData(1);
                    } else {
                        Alert.error(res.message)
                    }
                }).catch(error => {
                    Alert.error(error.message)
                })
            }
        });
    };

    const columns = useMemo(() => [
        {
            name: 'Title',
            selector: row => {
                if (!row.title) {
                    return <div>-</div>
                }
                return row.title
            },
            width: '200px',
            wrap: true,
            style: {
                whiteSpace: 'normal',
                wordWrap: 'break-word',
                overflow: 'hidden',
            }
        },
        {
            name: 'Message',
            selector: row => {
                if (!row.message) {
                    return <div>-</div>
                }
                return row.message;
            },
            wrap: true,
            grow: 2,
            style: {
                whiteSpace: 'normal',
                wordWrap: 'break-word',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            }
        },
        {
            name: 'Image',
            selector: row => {
                if (!row.image_url) {
                    return <div>-</div>
                }
                return <img src={row.image_url} width="80px" alt="notification" style={{ borderRadius: '4px' }} />
            },
            width: '120px',
        },
        {
            name: 'Action',
            cell: row => (
                <button
                    type="button"
                    className="btn btn-outline-danger btn-sm btn-rounded waves-effect waves-light"
                    onClick={() => onDelete(row._id)}
                >
                    <i className='bx bxs-trash'></i> Delete
                </button>
            ),
            width: '120px',
        },
    ]
    );

    const notificationData = async (page, pageSize = perPage) => {
        setLoading(true);
        var sendd = { page: page, size: pageSize, search: '' };
        const response = await Api.post('notification/list', sendd);
        setData(response.data.data.docs);
        setTotalRows(response.data.data.totalDocs);
        setLoading(false);
    };
    const handlePageChange = page => {
        notificationData(page);
    };
    const handlePerRowsChange = async (newPerPage, page) => {
        setPerPage(newPerPage);
        notificationData(page, newPerPage);
    };

    useEffect(() => {
        notificationData(1);
    }, []);

    const customStyles = {
        headCells: {
            style: {
                fontWeight: 'bold',
                fontSize: '14px',
            },
        },
        cells: {
            style: {
                paddingTop: '12px',
                paddingBottom: '12px',
            },
        },
    };

    return (
        <>
            <section className="main-content userlist_main_sec">
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="header-text">
                                            <h4 className="card-title mb-4">Notifications</h4>
                                            <div className="edit-btn">
                                                <Link to="/notification/add" className="btn btn-outline-primary mr-4 btn-sm btn-rounded waves-effect waves-light">
                                                    <i className='bx bx-add-to-queue'></i>
                                                    Add
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="table-responsive" style={{ overflow: 'hidden' }}>
                                            <DataTable
                                                columns={columns}
                                                data={data}
                                                progressPending={loading}
                                                pagination
                                                paginationServer
                                                paginationTotalRows={totalRows}
                                                onChangeRowsPerPage={handlePerRowsChange}
                                                onChangePage={handlePageChange}
                                                customStyles={customStyles}
                                                responsive
                                            />
                                        </div>
                                        {/* end table-responsive  */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default withRouter(NotificationList);